/**
 * The type of the image captured
 *
 * @internal
 */
export enum RequiredInputImage {
	/**
	 * A document captured with an IR camera.
	 */
	NearInfraredImage = 'NearInfraredImage',
	/**
	 * A self-portrait of the customer captured with a normal RGB camera.
	 */
	SelfiePhoto = 'SelfiePhoto',
	/**
	 * A document captured with a UV camera.
	 */
	UltravioletImage = 'UltravioletImage',
	/**
	 * A document captured with a normal RGB camera.
	 */
	WhiteImage = 'WhiteImage'
}
